import { isObject } from "@perxis-auto/shared";
import { getCatalogCatalogGet, getEstimateEstimatePost, createReportReportsPost, getReportReportsReportIdGet } from "../../shared/api/services.gen.js";
import { WidgetType, ReportStatus } from "../../shared/api/types.gen.js";
import { createAppAsyncThunk } from "../../shared/lib/store/createAppAsyncThunk.js";
import ApiService from "../../shared/services/ApiService.js";
import { selectConfig } from "../config/selectors.js";
import { selectFieldById, selectCurrentEntity as selectCurrentEntity$1 } from "../stages/selectors.js";
import { selectFieldIsMissingDependentFieldValuesById, selectDependFieldValuesByFieldId, selectCurrentEntity } from "./selectors.js";
const getOptions = createAppAsyncThunk(
  "forms/getOptions",
  async ({ fieldId, formId }, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const { clientId } = selectConfig(state);
      const apiClient = ApiService.getInstance().client;
      const isMissingDependentFieldValues = selectFieldIsMissingDependentFieldValuesById(state, {
        fieldId,
        formId
      });
      const field = selectFieldById(state, {
        fieldId,
        formId
      });
      if (!field) {
        throw new Error("Не удалось найти поле");
      }
      if ([WidgetType.INPUT, WidgetType.CHECKBOX].includes(field.widget)) {
        return;
      }
      if (isMissingDependentFieldValues) {
        throw new Error("Отсутствуют значения у полей, от которых зависит поле");
      }
      const dependFieldValues = selectDependFieldValuesByFieldId(state, { fieldId, formId });
      const getCatalogQuery = Object.entries(dependFieldValues || {}).reduce(
        (acc, [fieldId2, field2]) => {
          if (isObject(field2) && "id" in field2) {
            return {
              ...acc,
              [fieldId2]: field2.id
            };
          }
          return {
            ...acc,
            [fieldId2]: field2
          };
        },
        {}
      );
      const { data: catalogSchema } = await getCatalogCatalogGet({
        client: apiClient,
        query: {
          ...getCatalogQuery,
          field_id: fieldId
        },
        headers: {
          "X-Client-Id": clientId
        }
      });
      if (!catalogSchema) {
        throw new Error("Не удалось найти католог значений");
      }
      return {
        fieldId: catalogSchema.field_id,
        values: catalogSchema.values
      };
    } catch (error) {
      throw thunkAPI.rejectWithValue({
        errorMessage: error instanceof Error ? error.message : "Ошибка!",
        meta: { action: "forms/getOptions" }
      });
    }
  }
);
const submitForm = createAppAsyncThunk("forms/submitForm", async (_, thunkAPI) => {
  const state = thunkAPI.getState();
  const currentForm = selectCurrentEntity(state);
  const currentStage = selectCurrentEntity$1(state);
  try {
    if (!currentForm || !currentStage) {
      throw new Error("Не удалось найти текущую стадию и форму");
    }
    const ACTIONS_MAP = {
      // @ts-ignore
      "/trade-in/api/v1/reports/": getReport,
      // @ts-ignore
      "/trade-in/api/v1/estimate/": getEstimate
    };
    const action = ACTIONS_MAP[currentStage.form.handler];
    if (!action) {
      throw new Error("Не удалось найти обработчик для формы");
    }
    const result = await thunkAPI.dispatch(action()).unwrap();
    return {
      formId: currentForm.id,
      result
    };
  } catch (error) {
    throw thunkAPI.rejectWithValue({
      errorMessage: error instanceof Error ? error.message : "Ошибка!",
      meta: {
        action: "forms/submitForm",
        formId: currentForm == null ? void 0 : currentForm.id
      }
    });
  }
});
const getEstimate = createAppAsyncThunk("forms/getEstimate", async (_, thunkAPI) => {
  try {
    const state = thunkAPI.getState();
    const { clientId } = selectConfig(state);
    const apiClient = ApiService.getInstance().client;
    const currentForm = selectCurrentEntity(state);
    const getEstimateBody = currentForm == null ? void 0 : currentForm.fields;
    const { data: estimateSchema } = await getEstimateEstimatePost({
      client: apiClient,
      body: getEstimateBody,
      headers: {
        "X-Client-Id": clientId
      }
    });
    if (!estimateSchema) {
      const estimateSchemaError = new Error("Для редких, битых и новых машин не получится посчитать рыночную цену.");
      estimateSchemaError.name = "Estimate not found";
      throw estimateSchemaError;
    }
    return estimateSchema;
  } catch (error) {
    if (error instanceof Error) {
      throw thunkAPI.rejectWithValue({
        errorMessage: error.message,
        meta: {
          action: "forms/getEstimate",
          ...error.name === "Estimate not found" && { title: "Нет оценки" }
        }
      });
    }
    throw thunkAPI.rejectWithValue({
      errorMessage: "Ошибка!",
      meta: {
        action: "forms/getEstimate"
      }
    });
  }
});
const getReport = createAppAsyncThunk("forms/getReport", async (_, thunkAPI) => {
  try {
    const state = thunkAPI.getState();
    const { clientId, report: reportConfig } = selectConfig(state);
    const apiClient = ApiService.getInstance().client;
    const currentForm = selectCurrentEntity(state);
    const createReportBody = currentForm == null ? void 0 : currentForm.fields;
    const { data: createReportSchema } = await createReportReportsPost({
      client: apiClient,
      body: createReportBody,
      headers: {
        "X-Client-Id": clientId
      }
    });
    if (!createReportSchema) {
      throw new Error("Не удалось создать заявку на отчет по автомобилю");
    }
    let counter = 0;
    const preparedReport = await new Promise((resolve, reject) => {
      const getPreparedReport = async () => {
        try {
          const getReportPath = createReportSchema;
          const { data: reportSchema } = await getReportReportsReportIdGet({
            client: apiClient,
            path: getReportPath
          });
          if (!(reportSchema == null ? void 0 : reportSchema.report) || !(reportSchema == null ? void 0 : reportSchema.status) || ![ReportStatus.PROCESSING, ReportStatus.SUCCESS].includes(reportSchema.status)) {
            reject(new Error("Не удалось получить отчет по автомобилю"));
            return;
          }
          if (reportSchema.status === ReportStatus.PROCESSING) {
            if (counter < reportConfig.attempts) {
              setTimeout(getPreparedReport, reportConfig.interval);
              return;
            }
            reject(new Error("Не удалось получить отчет по автомобилю"));
          }
          resolve(reportSchema.report || []);
        } catch (e) {
          reject(new Error("Не удалось получить отчет по автомобилю"));
        } finally {
          counter += 1;
        }
      };
      getPreparedReport();
    });
    return preparedReport;
  } catch (error) {
    throw thunkAPI.rejectWithValue({
      errorMessage: error instanceof Error ? error.message : "Ошибка!",
      meta: {
        action: "forms/getReport"
      }
    });
  }
});
export {
  getEstimate,
  getOptions,
  getReport,
  submitForm
};
